
// HomeSectionCarousel.jsx
import React, { useState } from "react";
import HomeSectionCard from "../HomeSectionCard/HomeSectionCard";
import { CustomNextArrow, CustomPrevArrow } from "../Home/SettingsAndArrows";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import useUIStyles from "../../../Hooks/useUIStyles";

const HomeSectionCarousel = ({ sectionName, products }) => {
  const { heading, title, description } = useUIStyles();
  const [currentSlide, setCurrentSlide] = useState(0);

  // Create viewAllLink from sectionName with fallback
  const viewAllLink = sectionName ? `/${sectionName}` : '/';


  const filteredProducts =
    products?.filter(
      (item) => item.category?.name === sectionName
    ) || [];

  while (filteredProducts.length < 4 && filteredProducts.length > 0) {
    filteredProducts.push(<div key={`placeholder-${filteredProducts.length}`} className="opacity-10" />);
  }

  const settings = {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 3,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    prevArrow: <CustomPrevArrow currentSlide={currentSlide} />,
    nextArrow: (
      <CustomNextArrow
        currentSlide={currentSlide}
        slideCount={filteredProducts?.length || 0}
      />
    ),
    responsive: [
      {
        breakpoint: 1440,
        settings: { slidesToShow: 4, slidesToScroll: 3 },
      },
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4, slidesToScroll: 3 },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3, slidesToScroll: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 360,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
    ],
  };

  return (
    filteredProducts?.length > 0 && sectionName && viewAllLink ? (
      <section className="pt-8 px-3 sm:px-4 bg-white pb-2">
        <div className="max-w-7xl mx-auto bg-cream rounded-[28px] py-8 px-4 sm:px-8">
          <div className="relative mb-8 text-center">
            <h2 className="section-heading text-[28px] md:text-[32px] leading-9">
              {sectionName}
            </h2>
            <a
              href={viewAllLink}
              className="absolute right-0 top-1/2 -translate-y-1/2 hidden sm:inline text-stone-500 hover:text-stone-800 text-[11px] tracking-[0.16em] uppercase"
            >
              View all
            </a>
          </div>
          <div className="relative">
            <div className="w-full relative overflow-hidden">
              <Slider {...settings}>
                {filteredProducts?.map((product, index) => (
                  <div key={product.id}>
                    <HomeSectionCard product={product} />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
        <style>
          {`
            .slick-slide > div {
              margin: 0 8px; /* ✅ gap between products */
            }
            .slick-list {
              margin: 0 -8px; /* ✅ remove extra space from edges */
            }
          `}
        </style>
      </section>
    ) : null
  );
};

export default HomeSectionCarousel;

